//Proofed

import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { NAVBAR_BG } from '../common/theme'
import { FancyButton } from '../comps/FancyButtons'

function getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
    return match ? decodeURIComponent(match[1]) : null
}

function createCookie(name: string, value: string, days: number) {
    const expires = new Date()
    expires.setDate(expires.getDate() + days)
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`
}

export default function CookieBar() {
    const [visible, setVisible] = useState(() => getCookie('cookiebar') !== 'CookieAllowed')

    if (!visible) return null

    const allowCookies = () => {
        createCookie('cookiebar', 'CookieAllowed', 100)
        setVisible(false)
    }

    return (
        <Box data-testid="cookiebar_root" sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1300,
            backgroundColor: NAVBAR_BG,
            borderTop: '1px solid rgba(255,255,255,0.1)',
            px: { xs: 2, md: 4 },
            py: 2,
        }}>
            {/* Top row: header + privacy link + allow button */}
            <Box sx={{
                display: 'flex',
                alignItems: { xs: 'flex-start', sm: 'center' },
                justifyContent: 'space-between',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: 1.5,
                mb: 1,
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap' }}>
                    <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '15px' }}>
                        Cookies on ContractFinderPro.com
                    </Typography>
                    <Box
                        data-testid="cookiebar_privacy_link"
                        component={Link}
                        to="/privacy"
                        sx={{
                            display: 'flex', alignItems: 'center', gap: 0.5,
                            color: 'rgba(255,255,255,0.6)',
                            textDecoration: 'none',
                            fontSize: '13px',
                            '&:hover': { color: 'white' },
                        }}
                    >
                        View Privacy Policy
                    </Box>
                </Box>
                <FancyButton
                    testId="cookiebar_allow_btn"
                    onClick={allowCookies}
                    solid
                >
                    Allow Cookies
                </FancyButton>
            </Box>

            {/* Body text */}
            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.5)', display: 'block', mb: 0.5 }}>
                We use some essential cookies to enhance browsing experience, provide functionality and improve our services.
            </Typography>
            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.5)', display: 'block' }}>
                We also use cookies set by other sites to help us deliver content from their services which includes data collection for ads personalisation.
            </Typography>
        </Box>
    )
}
